import { Tooltip, TooltipContent, TooltipTrigger } from "@/shared/ui/tooltip";
import { cn } from "@/shared/lib/utils";

interface CompletenessBadgeProps {
  included: number;
  total: number;
  reason?: string;
}

/**
 * Phantom-gap defense badge. Shown next to a section title when the data set
 * is a subset of the universe the agent considered. Hover surfaces the reason
 * the rest was excluded ("SKIPPED_NO_NAMEPLATE", "Top N filter applied", ...).
 */
export function CompletenessBadge({ included, total, reason }: CompletenessBadgeProps) {
  if (total === 0 || included === total) return null;
  const ratio = included / total;
  const tone = ratio < 0.5 ? "warning" : "muted";
  const label = `${included.toLocaleString()} of ${total.toLocaleString()}`;
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          className={cn(
            "inline-flex items-center rounded-full border px-1.5 py-0.5 text-[10px] font-medium uppercase tracking-wide tabular-nums",
            tone === "warning"
              ? "border-status-warning/40 bg-status-warning/10 text-status-warning"
              : "border-border bg-muted/40 text-muted-foreground",
          )}
        >
          {label}
        </span>
      </TooltipTrigger>
      <TooltipContent side="bottom" className="max-w-xs text-xs">
        {reason ?? `${included.toLocaleString()} of ${total.toLocaleString()} included.`}
      </TooltipContent>
    </Tooltip>
  );
}
